<form [formGroup]="form" (ngSubmit)="save()">
  <h1 mat-dialog-title [translate]="'parameters/quick_replies/details/graph/recurring_notif_box_title'"></h1>

  <mat-dialog-content>
    <div *ngIf="loading" class="alc-spinner-wrapper-in-flow">
      <mat-spinner diameter="50" color="accent"></mat-spinner>
    </div>

    <ng-container *ngIf="pictureUrl; else noPicture">
      <img [appJwtSrc]="pictureUrl" />

      <div class="alc-margin-top-16 alc-margin-bottom-16">
        <button mat-raised-button type="button" (click)="uploadFile.click()">
          <mat-icon>image</mat-icon>
          <span translate="parameters/quick_replies/details/graph/edit_recurring_notif_box_picture_edit"></span>
        </button>
        <button mat-raised-button type="button" (click)="removeImage()">
          <mat-icon>delete</mat-icon>
          <span translate="parameters/quick_replies/details/graph/edit_recurring_notif_box_picture_remove"></span>
        </button>
      </div>
    </ng-container>
    <ng-template #noPicture>
      <div class="alc-margin-top-16 alc-margin-bottom-16">
        <button mat-raised-button type="button" (click)="uploadFile.click()">
          <mat-icon>image</mat-icon>
          <span translate="parameters/quick_replies/details/graph/edit_recurring_notif_box_picture_add"></span>
        </button>
      </div>
    </ng-template>

    <input
      #uploadFile
      type="file"
      accept="image/*"
      (change)="uploadImage($event)"
      fileread="filenames.picture"
      hidden />

    <app-select
      [control]="form.controls.optinId"
      [items]="optinItems"
      [labelKey]="'parameters/quick_replies/details/graph/edit_recurring_notif_box_optin_label'">
    </app-select>

    <mat-form-field *ngIf="form.getRawValue().title">
      <mat-label translate="parameters/quick_replies/details/graph/edit_recurring_notif_box_optin_title"></mat-label>
      <input matInput formControlName="title" type="text" />
    </mat-form-field>

    <app-select
      *ngIf="form.controls.ctaText.enabled"
      [control]="form.controls.ctaText"
      [items]="ctaTextChoices"
      [labelKey]="'parameters/quick_replies/details/edit_button/label'">
    </app-select>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button type="submit" color="primary" [disabled]="form.invalid">
      <span translate="save"></span>
    </button>
    <button mat-raised-button type="button" mat-dialog-close><span translate="cancel"></span></button>
  </mat-dialog-actions>
</form>
